import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-4",
  "use": "icon-icon-nav-4-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-4\"><path d=\"M747.2 243.2H606.72A101.12 101.12 0 0 0 512 176 101.12 101.12 0 0 0 417.28 243.2H276.8c-36.992 0-67.2 30.272-67.2 67.2v470.4c0 36.992 30.272 67.2 67.2 67.2h470.4c36.928 0 67.2-30.272 67.2-67.2V310.4c0-36.928-30.272-67.2-67.2-67.2zM512 243.2c18.496 0 33.6 15.104 33.6 33.6A33.728 33.728 0 0 1 512 310.4a33.728 33.728 0 0 1-33.6-33.6c0-18.496 15.104-33.6 33.6-33.6z m-67.2 470.4l-134.4-134.4 47.36-47.36 87.04 86.656 221.44-221.44 47.36 47.744-268.8 268.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-4.svg
// module id = q6i1
// module chunks = 3